import { useTranslation } from 'react-i18next';
import * as v from 'valibot';
import { isValidId } from 'balus-common';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';

const SearchViewModelsOutputSchema = v.looseObject({
  hits: v.array(v.looseObject({ id: v.string(), title: v.string() })),
});

type Hit = { id: string; title: string };

// hit の uri は外部の検索 API が返す値なので使わず、ID からこのアプリのパスを組み立てる
function toHits(output: unknown): Hit[] {
  const parsed = v.safeParse(SearchViewModelsOutputSchema, output);
  return parsed.success ? parsed.output.hits.filter((hit) => isValidId(hit.id)) : [];
}

export function SearchViewModelHitLinks({ output }: { output: unknown }) {
  const { t } = useTranslation();
  const hits = toHits(output);
  if (hits.length === 0) return null;

  return (
    <ul className="my-1 flex flex-col gap-0.5 text-xs">
      {hits.map((hit, index) => (
        <li key={`${hit.id}-${index}`} className="truncate">
          <a
            href={UserPagePathBuilder.viewModelPage(hit.id)}
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 underline-offset-2 hover:underline"
          >
            {hit.title || t('viewModel.aiChat.noTitle')}
          </a>
        </li>
      ))}
    </ul>
  );
}
